module.exports = __webpack_public_path__ + "media/images/icons/inmail-d9fda6f7409749d664215497d1dc20a3.svg";